<template>
  <div v-if="!isWebView" class="z-30 shrink-0 bg-[#191c20]">
    <div class="relative flex items-center justify-between px-16 h-48">
      <template v-if="closeButton">
        <div class="w-48" />
      </template>
      <template v-else>
        <RevButtonIcon
          :alternative-text="i18n(translations.back)"
          :icon="IconArrowLeft"
          :to="back"
          :tracking="{ zone: trackingZone, name: 'back' }"
          variant="ghost"
          @click="handleBack"
        />
      </template>

      <p
        class="body-1 absolute inset-x-0 px-48 text-center truncate text-static-default-hi [transform:translateZ(0)] pointer-events-none"
      >
        {{ title }}
      </p>

      <slot name="right">
        <template v-if="closeButton">
          <RevButtonIcon
            :alternative-text="i18n(dsTranslations.buttonClose)"
            :icon="IconCross"
            :to="back"
            :tracking="{ zone: trackingZone, name: 'back' }"
            variant="ghost"
            @click="handleBack"
          />
        </template>
        <template v-else>
          <div class="w-48" />
        </template>
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from '#imports'
import type { RouteLocationRaw } from 'vue-router'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useIsWebview } from '@backmarket/nuxt-module-navigation/useIsWebview'
import { RevButtonIcon } from '@ds/components/ButtonIcon'
import { IconArrowLeft } from '@ds/icons/IconArrowLeft'
import { IconCross } from '@ds/icons/IconCross'
import { dsTranslations } from '@ds/translations'

import translations from './OutletTopBar.translations'

const props = withDefaults(
  defineProps<{
    title: string
    back?: RouteLocationRaw
    trackingZone?: string
    closeButton?: boolean
  }>(),
  {
    trackingZone: 'top_bar',
    closeButton: false,
  },
)

const router = useRouter()
const i18n = useI18n()
const isWebView = useIsWebview()

function handleBack() {
  if (!props.back) {
    router.back()
  }
}
</script>
